import * as types from '../../action-types';
import {getMyISODeals as initialState } from "../../initialState";

const getMyISODeals = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_MY_ISO_DEALS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_MY_ISO_DEALS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_MY_ISO_DEALS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_MY_ISO_DEALS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getMyISODeals;
